export default __webpack_public_path__ + "static/media/dev.dd59f241.svg";